import React, { useState, useEffect } from "react";
import RequestService from "../services/RequestService";
import { FaCircle } from "react-icons/fa";
import { parseISO, format, differenceInHours } from "date-fns";
import SendModal from './modals/SendModal';
import RequestDetailsModal from "./modals/RequestDetailsModal";
import { FaLongArrowAltDown } from "react-icons/fa";
import { isSLAPassed, isSLANear, isSLATwoHour } from "../utils/SLACalcs";
import BoardingModal from "./modals/BoardingModal";
import { IoMdSend } from "react-icons/io";
import StatusRequests from './../enums/StatusRequests';
import { RiTimerLine } from "react-icons/ri";
import { AiFillAlert } from "react-icons/ai";
import { useOutletContext } from 'react-router-dom';
import SendToManagementModal from './modals/SendToManagementModal';
import { startPolling } from "../utils/polling";


export default function Delivery() {

  const statusColor = {
    "REPASSE PARA COLETA": "#bae6fd",
    "ROTA DE COLETA": "#38bdf8",
  }

  const { user } = useOutletContext();

  const [sendModal, setSendModal] = useState(false);
  const [requestOnSendModal, setRequestOnSendModal] = useState();
  const [requestNroOnSendModal, setRequestNroOnSendModal] = useState();

  const [deliverModal, setDeliverModal] = useState(false);

  const [requestDetailsModal, setRequestDetailsModal] = useState(false);
  const [requestOnDetailsModal, setRequestOnDetailsModal] = useState();

  const [requestListRepasse, setRequestListRepasse] = useState({ requests: [], totalPages: 1 });
  const [currentPageRepasse, setCurrentPageRepasse] = useState(1);

  const [boardingModal, setBoardingModal] = useState(false)
  const [requestOnBoardingModal, setRequestOnBoardingModal] = useState();

  const [sendToManagementModal, setSendToManagementModal] = useState(false);
  const [requestOnMngtModal, setRequestOnMngtModal] = useState();

  //filters
  const [search, setSearch] = useState('');
  const [tempSearch, setTempSearch] = useState(''); // Estado temporário para o input
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  // const [status, setStatus] = useState('');


  useEffect(() => {
    
    const fetchRequests = async () => {
      const status = 'REPASSE PARA ENTREGA'
      const params = new URLSearchParams();
      if (search) params.append('search', search);
      if (startDate) params.append('startDate', startDate);
      if (endDate) params.append('endDate', endDate);
      if (status) params.append('status', status);

      const queryString = params.toString();
      const requestsRepasse = await RequestService.getRequest(`?${queryString}`, currentPageRepasse);
      setRequestListRepasse(requestsRepasse);
    };

    // Chamada inicial
    const fetchData = () => {
      fetchRequests();
    };

    fetchData()

    return startPolling(fetchData);

  }, [currentPageRepasse, endDate, search, startDate, sendModal]);

  const handlePageChangeRequests = (newPage) => {
    if (newPage >= 1 && newPage <= requestListRepasse.totalPages) {
      setCurrentPageRepasse(newPage);
    }
  };

  const handleEnviar = async (ticketId, requestNro) => {
    setSendModal(true)
    setRequestOnSendModal(ticketId)
    setRequestNroOnSendModal(requestNro)
  };

  const handleRequestDetailsModal = async (ticketId) => {
    setRequestDetailsModal(true)
    setRequestOnDetailsModal(ticketId)
  };

  const handleBoardingModal = (ticketId) => {
    setBoardingModal(true)
    setRequestOnBoardingModal(ticketId)
  }

  const handleGestao = async (ticketId, requestNro) => {
    setSendToManagementModal(true)
    setRequestOnMngtModal(ticketId)
    // setRequestNroOnMngtModal(requestNro)
  };

  const renderFurtoVandalismoFlag = (request) => {
    if (!request?.isFurtoVandalismo) {
      return '-';
    }

    return (
      <div className="flex items-center justify-center gap-1 text-red-600 font-bold whitespace-nowrap">
        <span className="inline-block h-2.5 w-2.5 rounded-full bg-red-500"></span>
      </div>
    );
  };


  // ====== FILTER FUNCTIONS ====== 

  const clearFilters = () => {
    setSearch('');
    setTempSearch('');
    setStartDate('');
    setEndDate('');
    // setStatus('');
  };

  const handleSearchChange = (e) => {
    // setSearch(e.target.value);
    setTempSearch(e.target.value); // Atualiza o estado temporário
  };

  const handleSearchBlur = () => {
    setSearch(tempSearch); // Atualiza o estado principal quando o input perde o foco
    console.log(tempSearch);
  };

  const handleStartDateChange = (e) => {
    setStartDate(e.target.value);
    console.log(e.target.value)
  };

  const handleEndDateChange = (e) => {
    setEndDate(e.target.value);
    console.log(e.target.value)
  };

  // ====== END FILTER FUNCTIONS ====== 


  return (
    <div className="flex w-full h-full justify-center items-center py-4 px-4 bg-gray-200">

      <div className="flex flex-col w-full h-full rounded-xl py-8 px-6 gap-12 bg-white">

      <div className="flex flex-col w-full h-full gap-4 border border-gray-800 border-opacity-40 rounded-xl p-2">
          <div className="flex items-center gap-2 w-full text-sm font-semibold ps-2 mt-2">
            <FaCircle
              color={StatusRequests["REPASSE PARA ENTREGA"]?.cor}
              size={15}
            />
            REPASSE PARA ENTREGA
          </div>

          <div className="flex flex-col justify-between w-full h-full">

            <div className="flex flex-col gap-4">

              {/* FILTROS */}
              <div className="flex items-end w-full rounded-md gap-4 mt-2 text-[10px]">
                <div className="flex space-x-4 text-[12px]">
                  <div className="flex flex-col">
                    <label className="font-semibold ms-2">Pesquisar</label>
                    <input
                      type="text"
                      placeholder="Search"
                      value={tempSearch}  // Vincula o valor ao estado temporário
                      onChange={handleSearchChange}  // Atualiza o estado temporário em tempo real
                      onBlur={handleSearchBlur}  // Atualiza o estado principal ao perder o foco
                      className="block w-full h-5 rounded-2xl px-4 text-gray-900 shadow-sm placeholder:text-gray-400 border border-zinc-500 outline-none ring-0"
                    />
                  </div>
                  <div className="flex flex-col">
                    <label className="font-semibold ms-2">Data Início</label>
                    <input
                      type="date"
                      placeholder="Start Date"
                      value={startDate}
                      onChange={handleStartDateChange}
                      className="block w-full h-5 rounded-2xl px-4 text-gray-900 shadow-sm placeholder:text-gray-400 border border-zinc-500 outline-none ring-0"
                    />
                  </div>
                  <div className="flex flex-col">
                    <label className="font-semibold ms-2">Data Fim</label>
                    <input
                      type="date"
                      placeholder="End Date"
                      value={endDate}
                      onChange={handleEndDateChange}
                      className="block w-full h-5 rounded-2xl px-4 text-gray-900 shadow-sm placeholder:text-gray-400 border border-zinc-500 outline-none ring-0"
                    />
                  </div>
                  {/* <div className="flex flex-col">
                  <label className="font-semibold">Status</label>
                  <select
                    value={status}
                    onChange={handleStatusChange}
                    className="border border-gray-300 rounded px-2 py-2"
                  >
                    <option value="">Select Status</option>
                    <option value="active">Active</option>
                    <option value="inactive">Inactive</option>
                  </select>
                </div> */}
                </div>

                <div className="flex gap-2">
                  {/* <button onClick={handleSubmit} className="bg-zinc-800 hover:bg-zinc-700 text-white h-6 px-4 rounded-2xl w-40">
                  Buscar
                </button> */}
                  <button onClick={clearFilters} className="bg-zinc-800 hover:bg-zinc-700 text-white h-5 px-4 rounded-2xl w-40">
                    Limpar Filtros
                  </button>
                </div>
              </div>

              {/* TABELA */}
              <div className="overflow-x-auto">
                <table className="min-w-full bg-white rounded-lg text-[10px]">
                  <thead className="bg-[#bae6fd]">
                    <tr>
                      {/* <th className="py-2 px-4 border-b rounded-tl-lg">Tipo</th> */}
                      <th className="py-2 px-4 border-b rounded-tl-lg">Status</th>
                      <th className="py-2 px-4 border-b">ID</th>
                      <th className="py-2 px-4 border-b">Criado em</th>
                      <th className="py-2 px-4 border-b">Cod Sap</th>
                      <th className="py-2 px-4 border-b">Furto/Vand.</th>
                      <th className="py-2 px-4 border-b">DRS Atender</th>
                      <th className="py-2 px-4 border-b">Cidade</th>
                      <th className="py-2 px-4 border-b">Qtd a Atender</th>
                      <th className="py-2 px-4 border-b">Atendimento</th>
                      <th className="py-2 px-4 border-b">Técnico</th>
                      {/* <th className="py-2 px-4 border-b">Telefone</th> */}
                      <th className="py-2 px-4 border-b">Obs Entrega</th>
                      <th className="py-2 px-4 border-b"><div className="flex justify-center items-center">Data SLA<FaLongArrowAltDown /></div></th>
                      <th className="py-2 px-4 border-b rounded-tr-lg">Ação</th>
                    </tr>
                  </thead>
                  <tbody>
                    {/* {requestListRepasse?.requests?.length > 0 &&
                  <tr className="">
                    <td colSpan="13" className="bg-neutral-400 text-white ps-4 font-extralight py-1 rounded-full"><div className="flex gap-2 items-center"><IoMdArrowDropdown size={17}/>Solicitações</div></td>
                  </tr>
                  } */}
                    {requestListRepasse.requests?.map((request, index) => (
                      <tr
                        key={`request-${index}`}
                        className={`border-t hover:bg-gray-100 ${isSLAPassed(request.slaDate)
                          ? "bg-red-100"
                          : isSLANear(request.slaDate)
                            ? "bg-yellow-100"
                            : isSLATwoHour(request.slaDate)
                              ? "bg-yellow-200"
                              : ""
                          }`}
                      >
                        {/* <td className="py-1 px-4"><div className="flex justify-start items-center gap-2 text-[10px] font-semibold">SOLICITAÇÃO</div></td> */}
                        <td className="py-1 px-4">
                          <div className="flex justify-start items-center gap-2">
                            <FaCircle
                              color={"#bae6fd"}
                              size={15}
                            />
                            {request.status}
                          </div>
                        </td>
                        <td className="py-1 px-4 cursor-pointer underline font-bold" onClick={() => handleRequestDetailsModal(request._id)}>{request.idRequest}</td>
                        <td className="py-1 px-4">{format(parseISO(request.createdAt), 'dd/MM/yy HH:mm')}</td>
                        <td className="py-1 px-4 whitespace-nowrap">{request.codSap}</td>
                        <td className="py-1 px-4 text-center">{renderFurtoVandalismoFlag(request)}</td>
                        <td className="py-1 px-4"><div className="flex justify-center items-center gap-2">{request.drsAtender?.sigla}</div></td>
                        <td className="py-1 px-4"><div className="flex justify-start items-center gap-2">{request.cidadeEntrega === 'SÃO PAULO' ? 'SP-' + request.gmo.identificador : request.cidadeEntrega}</div></td>
                        <td className="py-1 px-4"><div className="flex justify-center items-center gap-2">{request.quantidadeAtender}</div></td>
                        <td className="py-1 px-4">
                          <div className="flex justify-center items-center gap-2">
                            {["bbn-alta", "bbn-media"].includes(request.tipoAtendimento) ? (
                              <span className="text-black font-bold rounded-lg px-1 bg-yellow-300">
                                {request.tipoAtendimento.toUpperCase()}
                              </span>
                            ) : (
                              request.tipoAtendimento.toUpperCase()
                            )}
                          </div>
                        </td>
                        <td className="py-1 px-4"><div className="flex justify-center items-center gap-2">{request.tecnico ? request.tecnico + "-" +request.telefone: request.user.name + "-" +request.user.phone}</div></td>
                        {/* <td className="py-1 px-4"><div className="flex justify-center items-center gap-2">{request.user.phone}</div></td> */}
                        <td className="py-1 px-4">{request.ultimaObs}</td>
                        <td
                          className={`py-1 px-4 ${request?.slaDate && isSLAPassed(request.slaDate)
                            ? "text-red-500 font-bold"
                            : request?.slaDate && isSLANear(request.slaDate)
                              ? "text-yellow-600 font-bold"
                              : request?.slaDate && isSLATwoHour(request.slaDate)
                                ? "text-yellow-600 font-bold animate-pulse-fast"
                                : ""
                            }`}
                        >
                          <div className="flex gap-1 items-center font-bold">
                            {request?.slaDate
                              ? format(parseISO(request.slaDate), "dd/MM/yy HH:mm")
                              : "N/A"}
                            {request?.slaDate && isSLATwoHour(request.slaDate) && (
                              <RiTimerLine size={12} />
                            )}
                          </div>
                        </td>
                        <td className="py-1 px-4">
                          <div className="flex justify-start gap-1 h-5 text-[11px]">
                            <button
                              className=" bg-gray-700 rounded-full px-2 text-white whitespace-nowrap"
                              // onClick={()=>generatePDF(request)}
                              onClick={() => handleBoardingModal(request._id)}
                            >
                              Nota Embarque
                            </button>
                            <button
                              className="flex  items-center gap-1 bg-sky-700 rounded-full px-2 text-white"
                              onClick={() => handleEnviar(request._id, request.idRequest)}
                            >
                              Enviar
                              <IoMdSend />
                            </button>
                            {(user.email === 'junior.silva@amerinode.com.br' || 
                              user.email === 'guilherme.alberto@amerinode.com.br' || 
                              user.email === 'jean.medeiros@amerinode.com.br' ||
                              user.email === 'marcio.almeida@amerinode.com.br' ||
                              user.email === 'maria.castro@amerinode.com.br' ||
                              user.email === 'renato.silva@amerinode.com.br') &&
                              <button
                                className="flex items-center gap-1 bg-rose-800 rounded-full px-2 text-white"
                                onClick={() => handleGestao(request._id, request.idRequest)}
                              >
                                Gestão
                                <AiFillAlert />
                              </button>
                            }
                          </div>
                        </td>
                      </tr>
                    ))}
                    {/* {collectOrdersRepasse?.collectOrders?.length > 0 &&
                  <tr>
                    <td colSpan="13" className="bg-neutral-400 text-white ps-4 font-extralight py-1 rounded-full"><div className="flex gap-2 items-center"><IoMdArrowDropdown size={17}/>Coletas</div></td>
                  </tr>
                  }
                  {collectOrdersRepasse.collectOrders?.map((collectOrder, index) => (
                    <tr key={index} className={`border-b hover:bg-gray-100 ${isSLAPassed(collectOrder.slaCollectDate) ? 'bg-red-50' : isSLANear(collectOrder.slaCollectDate) ? 'bg-yellow-50' : ''}`}>
                      <td className="py-1 px-4">
                        <div className="flex justify-start items-center gap-2">
                          <FaCircle
                          color={statusColor[collectOrder?.status]}
                          size={15}
                        />
                        {collectOrder.status}
                        </div>
                      </td>
                      <td className="py-1 px-4"><div className="flex justify-center items-center gap-2">-</div></td>
                      <td className="py-1 px-4">{format(parseISO(collectOrder.createdAt), 'dd/MM/yy HH:mm')}</td>
                      <td className="py-1 px-4 whitespace-nowrap">{collectOrder.codEquipamentoEsperado}</td>
                      <td className="py-1 px-4"><div className="flex justify-center items-center gap-2">-</div></td>
                      <td className="py-1 px-4"><div className="flex justify-center items-center gap-2">{collectOrder.gmo.cidade}</div></td>
                      <td className="py-1 px-4"><div className="flex justify-center items-center gap-2">{collectOrder.qtdEquipamentoEsperado}</div></td>
                      <td className="py-1 px-4"><div className="flex justify-center items-center gap-2">-</div></td>
                      <td className="py-1 px-4"><div className="flex justify-center items-center gap-2">{collectOrder.nomeSolicitante}</div></td>
                      <td className="py-1 px-4"><div className="flex justify-center items-center gap-2">-</div></td>                      
                      <td className="py-1 px-4">{collectOrder.observacaoColeta}</td>
                      <td className={`py-1 px-4 ${isSLAPassed(collectOrder.slaCollectDate) ? 'text-red-500 font-bold' : isSLANear(collectOrder.slaCollectDate) ? 'text-yellow-600 font-bold' : ''} `}>
                        {collectOrder?.slaCollectDate ? format(parseISO(collectOrder.slaCollectDate), 'dd/MM/yy HH:mm') : "" }
                      </td>
                      <td className="py-1 px-4">-</td>
                    </tr>
                  ))} */}
                  </tbody>
                </table>
              </div>
              
            </div>

            {/* Pagination Controls */}
            <div className="flex justify-center items-center mt-4 gap-2 text-xs">
              <button
                className={`px-2 py-1 rounded-md ${currentPageRepasse === 1 ? 'bg-gray-300 cursor-not-allowed' : 'bg-gray-300'}`}
                onClick={() => handlePageChangeRequests(currentPageRepasse - 1)}
                disabled={currentPageRepasse === 1}
              >
                {'<'}
              </button>
              {[...Array(requestListRepasse.totalPages)].map((_, index) => (
                <button
                  key={index}
                  className={`px-2 py-1 rounded-md ${currentPageRepasse === index + 1 ? 'bg-blue-500 text-white' : 'bg-gray-300'}`}
                  onClick={() => handlePageChangeRequests(index + 1)}
                >
                  {index + 1}
                </button>
              ))}
              <button
                className={`px-2 py-1 rounded-md ${currentPageRepasse === requestListRepasse.totalPages ? 'bg-gray-300 cursor-not-allowed' : 'bg-gray-300'}`}
                onClick={() => handlePageChangeRequests(currentPageRepasse + 1)}
                disabled={currentPageRepasse === requestListRepasse.totalPages}
              >
                {'>'}
              </button>
            </div>

          </div>
        </div>

      </div>
      
      { requestOnSendModal && 
      <div className="absolute">
        <SendModal
          isModalOpen={sendModal}
          setModalOpen={() => {
            setSendModal(!sendModal);
          }}
          requestId={requestOnSendModal}
          requestNro={requestNroOnSendModal}
          // setTicketCb={setTicket}
        ></SendModal>
      </div>
      }

      { requestOnBoardingModal && 
      <div className="absolute">
        <BoardingModal
          isModalOpen={boardingModal}
          setModalOpen={() => {
            setBoardingModal(!boardingModal);
          }}
          requestId={requestOnBoardingModal}
          // setTicketCb={setTicket}
        ></BoardingModal>
      </div>
      }

      {requestOnDetailsModal && 
        <div className="absolute">
          <RequestDetailsModal
            isModalOpen={requestDetailsModal}
            setModalOpen={() => {
              setRequestDetailsModal(!requestDetailsModal);
            }}
            requestId={requestOnDetailsModal}
            // setTicketCb={setTicket}
          ></RequestDetailsModal>
        </div>
      }

      {requestOnMngtModal &&
        <div className="absolute">
          <SendToManagementModal
            isModalOpen={sendToManagementModal}
            setModalOpen={() => {
              setSendToManagementModal(!sendToManagementModal);
            }}
            requestId={requestOnMngtModal}
          // requestNro={requestNroOnMngtModal}
          // setTicketCb={setTicket}
          ></SendToManagementModal>
        </div>
      }

    </div>
  )
}
